export const SET_WEATHER_DATA = "SET_WEATHER_DATA";
export const REQUEST_IN_PROGRESS = "REQUEST_IN_PROGRESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";